<template>
  <div class="header">
   <a-row>
     <a-col :span="8" class="d-flex header-menu">
       <p class="ml-10" @click="goUrl(item.path)" :class="$route.path == item.path?'active':''" :key="item.path" v-for="item in routers">{{$t(item.title)}}</p>
     </a-col>
     <a-col :span="8">
       <p class="text-center title over">
         {{ $t('login.a1') }}
       </p>
     </a-col>

     <a-col :span="8" class="text-right d-flex just-end">
       <a-dropdown  class="mr-10 mt-5" >
         <template #overlay>
           <a-menu @click="handleMenuClick">
             <a-menu-item  v-for="item in apps" :key="item.key"   :value="item.name" :appIcon="item.appIcon"  style="text-align: left;line-height: 25px;"  >
               <img class="mr-10" style="height: 25px;width: 25px;"   :src="httpRequest.axiosImgSmallUrl(item.appIcon)" alt="avatar" />
               {{ item.name}}
             </a-menu-item>
           </a-menu>
         </template>
         <a-button  type="text" style="color: white;" >
           <img class="mr-10" style="height: 25px;width: 25px;"   :src="httpRequest.axiosImgSmallUrl(appInfo.appIcon)" alt="avatar" />
           {{ appInfo.name}}
           <DownOutlined />
         </a-button>
       </a-dropdown>


       <a-dropdown class="mr-10">
        <span class="el-dropdown-link">
            <img class="mr-10" style="height: 25px;background: transparent;border: 0;border-radius: 0" :src="nowImg">
            {{ langName }}
        </span>
         <template #overlay>
           <a-menu>
             <a-menu-item @click="clickHandler(item)" :img="item.img" :key="item.content" v-for="item in options"
                          :value="item.value">
               <img class="mr-10" style="height: 25px;" :src="item.img">
               {{ item.content }}
             </a-menu-item>
           </a-menu>
         </template>
       </a-dropdown>

       <a-dropdown>
        <p class="color-white right">
          <img class="mr-10" v-if="userInfo.isAdmin == 1" src="../assets/root_icon.png">
          <img class="mr-10" v-else-if="userInfo.isAdmin == 2" src="../assets/admin_icon.png">
          <img class="mr-10" v-else src="../assets/user_icon.png">
          {{ userInfo.loginName }}
          <down-outlined style="margin-left: 4px;"/>
        </p>
         <template #overlay>
           <a-menu>
             <a-menu-item>
               <p style="margin: 0;width: 100%;" @click="resetPwd">{{ $t('login.b2') }}</p>
             </a-menu-item>
             <a-menu-item>
               <p style="margin: 0;width: 100%;" @click="showModal">{{ $t('login.b3') }}</p>
             </a-menu-item>
           </a-menu>
         </template>
       </a-dropdown>
     </a-col>
   </a-row>

    <a-modal v-model:visible="visible" :title="$t('login.b3')" @ok="logOut">
      <p>{{ $t('login.b4') }}</p>
    </a-modal>

    <a-modal width="400px" :maskClosable="false" :okText="$t('main.a8')" :cancelText="$t('main.a6')"  v-model:visible="dialogShowPwd" :title="$t('login.b2')" @ok="submit">
      <a-form
          :model="resetPasswords"
          ref="resetPassword"
          name="basic"
          autocomplete="off"
          layout="vertical"
      >
        <a-row>
          <a-col :span="24">
            <a-form-item
                :label="$t('user.b4')"
                name="password"
                :rules="[{ required: true, message: $t('login.b5') ,trigger: 'blur'}]"
            >
              <a-input-password :placeholder="$t('login.b5')"  v-model:value="resetPasswords.password" ></a-input-password>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item
                :label="$t('login.b6')"
                name="affirmPassword"
                :rules="[{ required: true, message: $t('login.b7') ,trigger: 'blur'}]"
            >
              <a-input-password  v-model:value="resetPasswords.affirmPassword" :placeholder="$t('login.b7')"></a-input-password>
            </a-form-item>
          </a-col>
        </a-row>

      </a-form>
    </a-modal>

  </div>
</template>
<script>
import {computed, reactive, ref,onMounted} from "vue";
import { useRoute,useRouter} from "vue-router";
import { useStore } from "vuex";
import { DownOutlined} from '@ant-design/icons-vue';
import {
  removeToken,
  removeUserInfo,
  removeUserName,
  removeImgUrl,
  getUserInfo,
  getTopRouters,
  setAppKey,getAppKey
} from "@/store/cache.js"
import {userresetPassword,appList} from "@/api";
import {message} from "ant-design-vue";
import {useI18n} from 'vue-i18n'
import zh_img from '@/assets/zh.png'
import en_img from '@/assets/en.png'
import i18n from "@/locales/setupI18n";
import httpRequest from '@/utils/request'
import {SubjectInstance } from '@/utils/publish-subject'


export default {
  components:{
    DownOutlined,
  },
  setup() {
    const {t} = i18n.global;

    const store = useStore();
    const $route = useRoute();
    const userInfo = getUserInfo();
    const dialogShowPwd = ref(false);
    let langName = ref('');
    const {locale} = useI18n();
    let nowImg = ref('');
    const options = [
      {content: '中文', value: 'zh_CN', img: zh_img},
      {content: 'English', value: 'en_US', img: en_img},
    ];
    onMounted(() => {
      // 设置暗色模式
      // document.documentElement.setAttribute('theme-mode', 'dark');
      let lang = store.state.language || 'zh_CN';
      options.map((e) => {
        if (e.value == lang) {
          langName.value = e.content;
          nowImg.value = e.img;
        }
      })
      initApps();
    })
    const clickHandler = (e) => {
      store.commit('changeLanguage', e.value);
      langName.value = e.content;
      locale.value = e.value;
      nowImg.value = e.img;
      document.title = t($route.meta.title) +' | '+t('main.b2');
    }
    const routers = getTopRouters() ? JSON.parse(getTopRouters()) : [];

    // const routers = ref([{
    //   title:'用户',
    //   key:'/user',
    //   icon:'icon-zhanghubaobiao',
    // },{
    //   title:'角色',
    //   key:'/role',
    //   icon:'icon-zhanghubaobiao',
    // },{
    //   title:'菜单',
    //   key:'/menu',
    //   icon:'icon-zhanghubaobiao',
    // }])
    // 用户名下拉菜单选择事件
    const urouter = useRouter();

    //侧边栏伸缩
    const collapsed = computed(() => store.state.collapse);
    // 侧边栏折叠
    const toggleCollapsed = () => {
      store.commit("handleCollapse", !collapsed.value);
    };
    const visible = ref(false);

    const showModal = () => {
      visible.value = true;
    }
    const logOut = () => {
      removeToken();
      removeUserInfo();
      removeUserName();
      removeImgUrl();
      localStorage.clear();
      // message.success( '您已退出登录')
      urouter.push("/login");
    }

    const goUrl = (e) => {
      urouter.push(e);
    }

    let resetPasswords = reactive({
      userId:'',
      password: "",
      affirmPassword: "",
    });
    //重置密码
    const resetPwd = () => {
      dialogShowPwd.value = true;
      resetPasswords.userId = userInfo.id
      resetPasswords.password = ''
      resetPasswords.affirmPassword = ''
    }

    const submit = async () => {
      let e = await userresetPassword(resetPasswords);
      if(e.code == 200){
        dialogShowPwd.value = false;
        message.success('重置密码成功')
      }
    }
    const apps = ref([]);

    const initApps = async () => {
      let cacheAppKey = getAppKey();

      let e = await appList({appKey:  userInfo.appKey});
      if(e.code == 200){
        let list = e.data
        apps.value = list || [];
        if(list){
          // 获取数据
          let d = JSON.parse(JSON.stringify(list[0]));

          if(cacheAppKey != null){
            for (let i = 0; i < list.length; i++) {
              let e = list[i];
              if(e.key == cacheAppKey){
                d = JSON.parse(JSON.stringify(e));
              }
            }
          }

          // 更新视图
          appInfo.value = d;

          // 保存数据
          setAppKey(appInfo.value.key)
        }
      }

    }
    const appInfo = ref({});

    const handleMenuClick = (e)=>{
      console.log(e);
      appInfo.value.name =  e.item.value;
      appInfo.value.key =  e.key;
      appInfo.value.appIcon =  e.item.appIcon;

      setAppKey(e.key)

      SubjectInstance.notify(e.key);

    }


    return {
      httpRequest,
      appInfo,
      handleMenuClick,
      apps,
      collapsed,
      toggleCollapsed,
      logOut,
      userInfo,
      goUrl,
      visible,
      showModal,
      routers,
      $route,
      dialogShowPwd,
      resetPwd,
      resetPasswords,
      submit,
      langName,
      clickHandler,
      options,
      nowImg
    };
  },
  mounted() {

  },
  methods:{

  }
};
</script>
<style lang="less" scoped>

.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  font-size: 18px;
  background-color:#0aa491!important;
}
.title{
  letter-spacing: 5px;
  line-height: 44px;
  color: white;
  font-weight: bold;
  margin-bottom: 0;
}
.over {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  word-break: keep-all;
  overflow-wrap: break-word;
}
.right{
  float: right;
  line-height: 44px;
  cursor: pointer;
  margin: 0;
  padding-right: 10px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.right img{
  width: 25px;
  height: 25px;
  margin-right: 5px;
}
.header-menu{
  display: flex;
  align-items: center;
  cursor: pointer;
  p{
    height: 35px;
    line-height: 38px;
    margin: 0;
    color: white;
    padding: 0 10px;
    font-size: 14px;
  }
  .active{
    background-color: #fff;
    color: #0aa491;
    border-radius: 5px;
  }
}
.el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: white;
  font-size: 14px;
  img {
    width: 25px;
    height: 25px;
    border: 2px solid white;
    background-color: white;
  }
}
</style>
